import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase";

// 管理画面(user/src/functions/getAiSdrConfig.js)と同じ既定値。
export const defaultAiSdrConfig = {
  enabled: false,
  brandName: "AIアシスタント",
  themeColor: "#4357C9",
  greetingText: "ご訪問ありがとうございます。ご質問があればお気軽にどうぞ。",
  quickReplies: [],
  knowledgeCharCount: 0,
  // 動画設置（管理画面の「動画設置」ページで設定される）
  videoDesktopUrl: null,
  videoMobileUrl: null,
  videoActiveVariant: null,
};

/**
 * ドメインから企業IDを引き、その企業の AI SDR 設定を返す。
 *
 * @param {string} domain enterprise.domain（サードレベルドメイン）
 * @returns {Promise<{enterpriseId: string|null, config: object}>}
 */
const getAiSdrConfig = async (domain) => {
  let enterpriseId = null;

  try {
    const enterpriseSnap = await getDocs(
      query(
        collection(db, "enterprise"),
        where("domain", "==", domain),
        limit(1)
      )
    );
    enterpriseSnap.forEach((element) => {
      enterpriseId = element.id;
    });
  } catch (error) {
    console.log("企業情報の取得に失敗", error);
  }

  if (enterpriseId === null) {
    return { enterpriseId: null, config: { ...defaultAiSdrConfig } };
  }

  try {
    const configSnap = await getDoc(doc(db, "aisdrConfig", enterpriseId));
    if (!configSnap.exists()) {
      return { enterpriseId, config: { ...defaultAiSdrConfig } };
    }
    const data = configSnap.data();
    const merged = { ...defaultAiSdrConfig };
    Object.keys(defaultAiSdrConfig).forEach((key) => {
      if (data[key] !== undefined && data[key] !== null) {
        merged[key] = data[key];
      }
    });
    return { enterpriseId, config: merged };
  } catch (error) {
    console.log("AI SDR設定の取得に失敗", error);
    return { enterpriseId, config: { ...defaultAiSdrConfig } };
  }
};

export default getAiSdrConfig;
